  <!-- My Account Update Profile -->
  <div class="preference_left--slider myacc-cont">

    <div class="preference_left--container">
      <div class="icon-cancel" (click)="goBack()"></div>

      <div class="preference_left--content">
        <!-- <div class="left_nav--logo"></div> -->

        <div class="preference_left--content_heading myacc-pages-hdng">
          <h2 class="heading">
            <p>{{'preferencecenterComp.preferencecenter1' | translate}} </p>
            <span class="back-icn" (click)="goBack()"> 
              <small class="show-desk">✕</small>
              <i class="icon icon-arrow-2 show-mobile"></i>
            </span>
          </h2>
        </div>

        <section class="preference-centre">
          <p>{{'preferencecenterComp.preferencecenter2' | translate}}</p>
          <div class="content">
            <div class="preference-list">
              <label for="emailOnly">
                <input id="emailOnly" name="preference" type="checkbox">
                <span class="prefer_check_text">
                  <h3>{{'preferencecenterComp.preferencecenter3' | translate}}</h3>
                  <p>{{'preferencecenterComp.preferencecenter4' | translate}}</p>
                </span>
              </label>
            </div>

            <div class="preference-list">
              <label for="smsOnly">
                <input id="smsOnly" name="preference" type="checkbox">
                <span class="prefer_check_text">
                  <h3>{{'preferencecenterComp.preferencecenter8' | translate}}</h3>
                  <!-- Mobile Promotional messages</b>-->
                  <p>{{'preferencecenterComp.preferencecenter5' | translate}}</p>
                </span>
              </label>
            </div>

            <!-- <hr> -->
            <div class="text-center">
              <button (click)="updatePreference('emailOnly','smsOnly')"
                class="prefer_btn site-btn site-btn__primary site-btn--lg">{{'preferencecenterComp.preferencecenter6' | translate}}</button>
            </div>
            <div *ngIf="message" class="successmsg text-center">
              <p>{{'preferencecenterComp.preferencecenter7' | translate}}</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>